import { useSelector } from 'react-redux';

import { useUserPermissions } from './userPermissions';
import { userTypes } from '../constants';

export const useSuspensionStatus = () => {
  const { type } = useUserPermissions();
  const { companyAdminInfo } = useSelector(store => store.currentCompany.companyAdminInfo);

  if (type !== userTypes.Contractor) {
    return false;
  }

  return companyAdminInfo?.isSuspended || false;
};
